import { render, staticRenderFns } from "./BookingSidebarBookingItem.vue?vue&type=template&id=740f0577&"
import script from "./BookingSidebarBookingItem.vue?vue&type=script&lang=js&"
export * from "./BookingSidebarBookingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports